import {
  blobDownloadResponseHandler,
  BlobDownload,
  EmptyResponse,
} from "@/utils/blob-response-handler";
import { toQueryParams } from "@/utils/to-query-params";
import { apiSlice } from "./http";

const RESOURCE_URL: string = "/operational-export";

export interface OperationalRangeParams {
  start: string;
  end: string;
}

export interface FiscalCycleReferenceParams {
  reference: string;
}

type ExportResult = BlobDownload | EmptyResponse;

export const operationalExportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    exportCashLosses: builder.query<ExportResult, OperationalRangeParams>({
      query: (range) => ({
        url: `${RESOURCE_URL}/losses/range?${toQueryParams(range)}`,
        method: "GET",
        responseHandler: (response: Response) =>
          blobDownloadResponseHandler<EmptyResponse>(response),
      }),
    }),

    exportPayrollDiscounts: builder.query<ExportResult, OperationalRangeParams>({
      query: (range) => ({
        url: `${RESOURCE_URL}/payroll-discounts/range?${toQueryParams(range)}`,
        method: "GET",
        responseHandler: (response: Response) =>
          blobDownloadResponseHandler<EmptyResponse>(response),
      }),
    }),

    exportConsolidatedLosses: builder.query<
      ExportResult,
      FiscalCycleReferenceParams
    >({
      query: (params) => ({
        url: `${RESOURCE_URL}/consolidated-losses/fiscal-cycle?${toQueryParams(
          params
        )}`,
        method: "GET",
        responseHandler: (response: Response) =>
          blobDownloadResponseHandler<EmptyResponse>(response),
      }),
    }),

    exportConsolidatedPayroll: builder.query<
      ExportResult,
      FiscalCycleReferenceParams
    >({
      query: (params) => ({
        url: `${RESOURCE_URL}/consolidated-payroll/fiscal-cycle?${toQueryParams(
          params
        )}`,
        method: "GET",
        responseHandler: (response: Response) =>
          blobDownloadResponseHandler<EmptyResponse>(response),
      }),
    }),
  }),
});

export const {
  useLazyExportCashLossesQuery,
  useLazyExportPayrollDiscountsQuery,
  useLazyExportConsolidatedLossesQuery,
  useLazyExportConsolidatedPayrollQuery,
} = operationalExportApi;
